var _rect, _script;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bars-rotate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    className: "nc-loop_bars-rotate-48",
    transform: "rotate(180 24 24)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 0,
    fill: "currentColor",
    width: 6,
    height: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 5.6,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 18.435 -23.3762)",
    fill: "currentColor",
    width: 6,
    height: 10,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 21,
    fill: "currentColor",
    width: 10,
    height: 6,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 32.4,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 90.3762 37.435)",
    fill: "currentColor",
    width: 6,
    height: 10,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 38,
    fill: "currentColor",
    width: 6,
    height: 10,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 32.4,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -8.435 71.3762)",
    fill: "currentColor",
    width: 6,
    height: 10,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21,
    fill: "currentColor",
    width: 10,
    height: 6,
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 5.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.3762 10.565)",
    fill: "currentColor",
    width: 6,
    height: 10,
    style: {
      opacity: 0.8
    }
  })), _script || (_script = /*#__PURE__*/React.createElement("script", null, "!function(){function t(t){this.element=t,this.animationId,this.start=null,this.init()}if(!window.requestAnimationFrame){var i=null;window.requestAnimationFrame=function(t,n){var e=(new Date).getTime();i||(i=e);var a=Math.max(0,16-(e-i)),o=window.setTimeout(function(){t(e+a)},a);return i=e+a,o}}t.prototype.init=function(){var t=this;this.animationId=window.requestAnimationFrame(t.triggerAnimation.bind(t))},t.prototype.reset=function(){var t=this;window.cancelAnimationFrame(t.animationId)},t.prototype.triggerAnimation=function(t){var i=this;this.start||(this.start=t);var n=t-this.start;800>n||(this.start=this.start+800),this.element.setAttribute(\"transform\",\"rotate(\"+parseInt(Math.min(n/100,8))%8*45+\" 24 24)\");if(document.documentElement.contains(this.element))window.requestAnimationFrame(i.triggerAnimation.bind(i))};var n=document.getElementsByClassName(\"nc-loop_bars-rotate-48\"),e=[];if(n)for(var a=0;n.length>a;a++)!function(i){e.push(new t(n[i]))}(a);document.addEventListener(\"visibilitychange\",function(){\"hidden\"==document.visibilityState?e.forEach(function(t){t.reset()}):e.forEach(function(t){t.init()})})}();"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingIcon);
export default __webpack_public_path__ + "static/media/UploadingIcon.b87f060b7de7ce13fc7ffac4786a9b2e.svg";
export { ForwardRef as ReactComponent };